// Swiper
import 'swiper/swiper-bundle.css';

// SCSS
import '../scss/plugins.scss';
